export default __webpack_public_path__ + "static/media/ns.5f9d6bcf.png";